import { Address } from '../models';

export const mockEndpointDelay = 200;
export const mockWebSocketDelay = 500;
export const mockSessionId = 'c297f836-d0f0-43a9-b64f-9cfeb9e28fcb';
export const mockSessionGuid = '7cc883e7-9bb1-4294-b7f4-d4efdf854157';
export const mockedNames: string[] = [
  'New Franklin',
  'Finn Goldstein',
  'Fischer Felix',
  'Holland Robert',
  'Green Adam',
  'Hansen Frank',
  'Gilbert Martin',
  'Weber Tim',
  'Fox Erik',
  'Foster Daniel',
  'Holland Robert',
  'Biggie Smalls',
  'Fox Frank',
  'Löwy Rupert',
  'Ester Victoria',
  'Phoenix Elisabeth',
];

export const mockedAddresses: Address[] = [
  {
    street: 'Viessmannstraße',
    houseNumber: '2',
    zip: '35108',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Kolpingstraße',
    houseNumber: '29',
    zip: '  52-120   ',
    city: 'Wrocław',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Friedrich-Bergius-Ring',
    houseNumber: '   14    ',
    zip: '97076',
    city: 'Würzburg',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Viessmannstraße',
    houseNumber: '    1   ',
    zip: '   35108  ',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Beetwiese',
    houseNumber: '   2    ',
    zip: '  35108   ',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Röddenauer Straße',
    houseNumber: '  12     ',
    zip: '   35066  ',
    city: 'Frankenberg',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: '',
    houseNumber: '       ',
    zip: '     ',
    city: 'Wrocław',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Kurhessenstraße',
    houseNumber: '     2  ',
    zip: '64546',
    city: 'Mörfelden-Walldorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Leipziger Str.',
    houseNumber: '     260  ',
    zip: '   34123  ',
    city: 'Kassel',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Str. der Nationen',
    houseNumber: '   7    ',
    zip: ' 30539    ',
    city: 'Hannover',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Viessmannstraße',
    houseNumber: '   1    ',
    zip: '   87787  ',
    city: 'Wolfertschwenden',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Viessmannstraße',
    houseNumber: '4       ',
    zip: ' 35108    ',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Beetwiese',
    houseNumber: '1',
    zip: '35108',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Kolpingstraße',
    houseNumber: '    45   ',
    zip: '35108',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Lilienthalstraße',
    houseNumber: '1',
    zip: '85570',
    city: 'Markt Schwaben',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Kolpingstraße',
    houseNumber: '11',
    zip: '35108',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
  {
    street: 'Viessmannstraße',
    houseNumber: '37',
    zip: '35108',
    city: 'Allendorf',
    region: null,
    country: 'de',
    faxNumber: null,
    geolocation: null,
    phoneNumber: null,
  },
];

export const getRandomMock = <T>(array: T[]): T => {
  return array[Math.floor(Math.random() * array.length)];
};
